export var actionTypes = {
    INPUT_CHANGE: '[form] Input Change',
    PREVENT_SUBMIT: '[form] Prevent Submit',
    SHOW_VALIDATION: '[form] Show Validation',
};
